import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { generateOrderOut, generateOrderOutCheckPlaceholder, getOrderOuts, postOrderOuts } from 'services'
import { Button, ButtonGroup } from 'stories/components'
import { confirm, generateErrorHtml } from 'utils'
import { RenderInput } from 'utils/RenderInput'
import { setLoanNumber } from 'utils/setLoanNumber'

const buttonGroup: Record<string, string> = {
  appraisal: 'Request For Appraisal',
  mortgage: 'Request for Verification of Mortgage/Rent',
  title: 'Request to order Title',
  insurance: 'Request for Evidence of Insurance',
  flood: 'Request for Flood Certification',
  escrow: 'Request to Open Escrow',
}
export const OrderOuts = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [button, setButton] = useState(Object.keys(buttonGroup)[0])
  const [data, setData] = useState<Record<string, any>>({})
  const [orgData, setOrgData] = useState<Record<string, any>>({})

  const loan = useSelector((state: any) => state.loan)

  useEffect(() => {
    setIsLoading(true)
    getOrderOuts().then((res) => {
      setData(res.data)
      setOrgData(res.data)
      setIsLoading(false)
    })
  }, [])

  const onChange = (key: string, value: any) => {
    const temp = cloneDeep(data)
    if (!temp[button]) temp[button] = {}
    temp[button].note = value
    setData(temp)
  }

  const onBlur = async (key: string, _value: any) => {
    const value = data[button]?.note
    if (!_value && value === orgData[button]?.note) return
    setIsLoading(true)
    await postOrderOuts({
      key: button,
      value,
    })
    setIsLoading(false)
    setOrgData(data)
  }

  const onGenerate = async () => {
    setIsLoading(true)
    const loanNumber = setLoanNumber()
    try {
      const emptyKeys = await generateOrderOutCheckPlaceholder(loanNumber, buttonGroup[button])
      if (emptyKeys.length) {
        const html = generateErrorHtml('Following fields are not filled. Please check them again.', emptyKeys)
        setIsLoading(false)
        const isContinue = await confirm(html, { titleYes: 'Generate', titleNo: 'Close' })
        if (!isContinue) {
          return
        }
        setIsLoading(true)
      }
      await generateOrderOut(loanNumber, buttonGroup[button], loan.byteproFileName)
    } catch (e) {}
    setIsLoading(false)
  }
  return (
    <div className="SSA-container relative">
      <LayoutLoading show={isLoading} />
      <div className="">
        <ButtonGroup title={buttonGroup} onChange={setButton} value={button} />
        <RenderInput
          input={{
            inputType: 'textarea',
            title: 'Notes',
            value: data[button]?.note || '',
          }}
          Key="notes"
          onChange={onChange}
          onBlur={onBlur}
        />
        <div className="flex justify-center mt-6">
          <Button onClick={onGenerate}>Generate</Button>
        </div>
      </div>
    </div>
  )
}
